import { DatePicker } from "antd";
import dayjs from "dayjs";
import React from "react";

const dateFormat = "YYYY/MM/DD";
export default function FilterTimeDate({ date, setDate }) {
  const onChange = (date, dateString) => {
    setDate(dateString);
  };

  const disabledDate = (current) => {
    return current && current > dayjs().endOf("day");
  };

  return (
    <DatePicker
      onChange={onChange}
      defaultValue={dayjs(date, dateFormat)}
      disabledDate={disabledDate}
    />
  );
}
